"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ATTRIBUTE_OWNER = void 0;
exports.ATTRIBUTE_OWNER = {
    CAMPAIGN: 'CAMPAIGN',
    CREW_PRICE: 'CREW_PRICE',
    CREW_VARIANT: 'CREW_VARIANT',
    CUSTOMER_SUBSCRIPTION: 'CUSTOMER_SUBSCRIPTION',
    FACE_MASK_PRICE: 'FACE_MASK_PRICE',
    LANDING_PRODUCT: 'LANDING_PRODUCT',
    ORDER: 'ORDER',
    PRODUCT: 'PRODUCT',
    PRODUCT_PRICE: 'PRODUCT_PRICE',
    STICKER_PRICE: 'STICKER_PRICE',
    TOTEBAG_PRICE: 'TOTEBAG_PRICE',
    TSHIRT_VARIANT: 'TSHIRT_VARIANT',
    TSHIRT_PRICE: 'TSHIRT_PRICE'
};
//# sourceMappingURL=attributeOwner.js.map